import React from "react";
import Types from "prop-types";
import { withTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import LanguageSelector from "../LanguageSelector";
import eventAnalytics from "../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../utils/constants";

const PAGE_NAME = "simple_confirmation_challenge";

export class SimpleConfirmationChallenge extends React.Component {
  constructor(props) {
    super(props);
    this.state = { email: props.email || "" };
    this.handleYes = this.handleYes.bind(this);
    this.handleNo = this.handleNo.bind(this);
  }

  componentDidMount() {
    eventAnalytics.publishViewPage(PAGE_NAME);
  }

  handleYes() {
    eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_TAP_BUTTON, {
      button_name: "yes",
    });
    this.props.onYes(this.state.email);
  }

  handleNo() {
    eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_TAP_BUTTON, {
      button_name: "no",
    });
    this.props.onNo(this.state.email);
  }

  render() {
    return this.renderClassic();
  }

  renderClassic() {
    const { t } = this.props;
    const { email } = this.state;
    return (
      <div>
        <Helmet>
          <title>Confirm Email | Careem</title>
        </Helmet>
        <LanguageSelector />
        <h1>{t("recover:confirm_email_title")}</h1>
        <h3>{email}</h3>
        <button
          type="button"
          className="btn-careem"
          onClick={this.handleYes}
        >
          {t("recover:confirm_email_yes")}
        </button>
        <button
          type="button"
          className="btn-careem-tertiary"
          onClick={this.handleNo}
        >
          {t("recover:confirm_email_no")}
        </button>
      </div>
    );
  }

}

SimpleConfirmationChallenge.propTypes = {
  t: Types.func.isRequired,
  email: Types.string,
  onYes: Types.func.isRequired,
  onNo: Types.func.isRequired,
};

SimpleConfirmationChallenge.defaultProps = {
  email: "",
};

export default withTranslation()(SimpleConfirmationChallenge);
